import { useState } from 'react';

interface ChatInterfaceProps {
  onSubmit: (message: string) => void;
  isLoading: boolean;
  placeholder: string;
}

export const ChatInterface = ({ onSubmit, isLoading, placeholder }: ChatInterfaceProps) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim() && !isLoading) {
      onSubmit(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div className="chat-interface">
      <form onSubmit={handleSubmit} className="chat-form">
        <div className="chat-input-container">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            className="chat-input"
            rows={4}
            disabled={isLoading}
          />
          <button 
            type="submit" 
            className="chat-submit-button"
            disabled={!message.trim() || isLoading}
          >
            {isLoading ? (
              <div className="loading-spinner">⏳</div>
            ) : (
              <div className="send-icon">🚀</div>
            )}
          </button>
        </div>
      </form>
      
      {isLoading && (
        <div className="generating-message">
          <div className="generating-content">
            <div className="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <p>Generating your quote...</p>
          </div>
        </div>
      )}
    </div>
  );
};